import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { makeRequest } from "../../apis/makeRequest";
import { getPresentaciones } from "../../apis/backendRequests";

const styles = {
  tableHead: {
    backgroundColor: "#225533",
  },
  tableCell: {
    color: "white"
  },
  textField: {
    width: "100%",
  },
  price: {
    fontFamily: "Montserrat, sans-serif",
    fontOpticalSizing: "auto",
    fontWeight: 600,
    fontStyle: "normal",
    letterSpacing: "2.34px",
    lineHeight: "19px",
    color: "grey",
  },
  description: {
    fontFamily: "Montserrat, sans-serif",
    letterSpacing: "2.34px",
    lineHeight: "19px",
    textTransform: "uppercase",
  },
  detalle: {
    fontFamily: "Montserrat, sans-serif",
    fontOpticalSizing: "auto",
    fontStyle: "normal",
    letterSpacing: "2.34px",
    lineHeight: "19px",
  },
  inputTextField: {
    "& input": { color: "black", textAlign: "center" },
  },
  button: {
    color: "white",
    backgroundColor: "black",
    padding: "10px",
    width: "100%",
    "&:hover": {
      backgroundColor: "grey",
    },
  },
};

const TableUnitCatalogo = ({ product, setterUnit, isEdit, submit, isClient }) => {
  const [variantes, setVariantes] = useState([]);
  const [unit, setUnit] = useState(isEdit || "");
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  useEffect(() => {
    if (!product) return;

    makeRequest(
      () => getPresentaciones(product.productId),
      (res) => setVariantes(res.data),
      null,
      { checkEmptyResults: false }
    );
  }, [product]);


  const changeValue = (e) => {
    const value = e.target.value
    setUnit(value)
    setterUnit(value)
  };


  const sendValue = (e) => {
    e.preventDefault()
    if (unit && unit > 0) {
      submit()
    }
  }

  const reordenVariantes = variantes.sort((a, b) => {
    const aValue = a.uofM;
    const bValue = b.uofM;

    const isAUnit = isNaN(parseInt(aValue.match(/\d+/)?.[0]));
    const isBUnit = isNaN(parseInt(bValue.match(/\d+/)?.[0]));

    if (isAUnit && !isBUnit) return -1; // "UNIDAD" al inicio
    if (!isAUnit && isBUnit) return 1;  // "UNIDAD" al inicio

    const numA = parseInt(aValue.match(/\d+/)?.[0]) || 0;
    const numB = parseInt(bValue.match(/\d+/)?.[0]) || 0;

    return numA - numB; // Orden numérico descendente
  });

  return (
    <form onSubmit={(e) => sendValue(e)}>
      <Stack spacing={1.5} >
        <Grid container sx={mobile ? { display: "flex", flexDirection: "column" } : {}} >
          <Grid item sm={12}>
            <Typography fontWeight={900} style={{ ...styles.description, padding: "15px 0px", fontSize: "16px", textShadow:"1px 1px 2px rgba(0, 0, 0, 0.3)" }}>{product.productDescription} - {product.productId}</Typography>
            <Typography fontWeight={700} style={{ ...styles.detalle, fontSize: "14px" }}>
              {product.productDescription1}
            </Typography>
            <Divider />
          </Grid>

          {isClient &&
            <>
              <Grid item sm={12} marginTop={"10px"} display="flex" justifyContent="space-between" alignItems="center">
                <Typography fontWeight={700} style={{ ...styles.detalle, fontSize: "14px", padding: "10px 0px" }}>Precio de venta</Typography>
                <Typography fontWeight={600} style={{ ...styles.detalle, fontSize: "14px" }}>
                  $ {product.unitPrice}
                </Typography>
              </Grid>
              <Divider style={{ width: "100%" }} />
            </>
          }

          <Grid item sm={12} marginTop={"10px"}>
            <Typography variant="h6" fontWeight={700} style={{ ...styles.detalle, fontSize: "14px", padding: "10px 0px" }}>Presentaciones</Typography>
            <Divider style={{ width: "95%" }} />
          </Grid>
          <Grid item sm={12} marginTop={"10px"} display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" gap="10px" >
            {reordenVariantes.map((variante, i) => (
              <Box
                key={variante.uofM}
                sx={{
                  width: "90%", cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  borderBlockEnd: "0.5px solid silver",
                }} >
                <Box sx={{ padding: "5px", display: "flex", justifyContent: "center" }}>
                  <Typography fontWeight={600} style={{ ...styles.detalle, fontSize: "13px" }}>{variante.uofM}</Typography>
                </Box>
              </Box>
            ))}
          </Grid>
          {isClient && <>
            <Grid item sm={12} marginTop={"10px"}>
              <TextField
                size="small"
                sx={styles.textField}
                type="number"
                onChange={changeValue}
                value={unit}
                InputProps={{
                  inputMode: "numeric",
                  placeholder: "0",
                  min: 0,
                  sx: styles.inputTextField,
                }}
              />
            </Grid>
            <Grid item sm={12} sx={styles.price} marginTop="10px">
              <Button
                sx={{
                  ...styles.button,
                  backgroundColor: "black",
                  "&:disabled": {
                    backgroundColor: "black", // Color para el estado deshabilitado
                    color: "white", // Cambia el color del texto si es necesario
                  },
                }}
                variant="contained"
                onClick={() => submit()}
                disabled={!unit || unit <= 0}
              >
                Agregar al carrito
              </Button>
            </Grid>
          </>
          }
          <Grid item sm={12} marginTop={"10px"} display={product.productDescription3 && product.productDescription3 !== "" && product.productDescription2 && product.productDescription2 !== "" ? "block" : "none"}>
            <Typography variant="h7" fontWeight={700} style={{ ...styles.detalle, fontSize: "15px", padding: "10px 0px" }}>Descripción del producto</Typography>
            <Divider style={{ width: "95%", marginBottom: "10px" }} />
            <Typography fontWeight={700} style={{ ...styles.detalle, fontSize: "13,5px", padding: "10px 0px" }}>{product.productDescription2}</Typography>

            <Typography fontWeight={600} style={{ ...styles.detalle, fontSize: "13px" }}>
              {product.productDescription3}
            </Typography>
          </Grid>
        </Grid>
      </Stack>
    </form>
  );
};

export default TableUnitCatalogo;

/* <Grid item sm={12} marginTop={"10px"}>
            <TextField
              size="small"
              sx={styles.textField}
              type="number"
              onChange={changeValue}
              value={unit}
              InputProps={{
                inputMode: "numeric",
                placeholder: "0",
                min: 0,
                sx: styles.inputTextField,
              }}
            />
          </Grid>
          <Grid item sm={12} sx={styles.price} marginTop="10px">
            <Button
              sx={styles.button}
              variant="contained"
              disabledBackground={"grey"}
              onClick={() => submit()}
              disabled={!unit || unit <= 0}
            >
              Agregar al carrito
            </Button> 
          </Grid>
            */